module.exports = __webpack_public_path__ + "img/img-subir-menu.dd30a366.png";